export const fr = {
    nav: {
        dashboard: 'Tableau de bord',
        board: 'Tableau',
        list: 'Liste',
        settings: 'Paramètres',
        reports: 'Rapports',
        myTasks: 'Mes tâches',
        activity: 'Activité',
        charts: 'Graphiques',
        team: 'Équipe',
        timeTracking: 'Suivi du temps',
        admin: 'Administration',
        adminOverview: 'Vue d\'ensemble admin',
        userManagement: 'Gestion des utilisateurs',
        projectSetup: 'Configuration du projet',
    },
    common: {
        projectManMD: 'ProjectManMD',
        markdownProjectManagement: 'Gestion de projet en Markdown',
        version: 'Version',
        back: 'Retour',
        loading: 'Chargement...',
        noData: 'Aucune donnée',
        search: 'Rechercher',
        filter: 'Filtrer',
        all: 'Tous',
        close: 'Fermer',
        open: 'Ouvrir',
        connect: 'Connecter',
        archived: 'Archivé',
        inactive: 'Inactif',
        active: 'Actif',
        untitled: 'Sans titre',
        unknown: 'Inconnu',
        tasks: 'Tâches',
        done: 'Terminé',
        lastModified: 'Dernière modification',
        created: 'Créé',
        points: 'Points',
        pts: 'pts',
        yes: 'Oui',
        no: 'Non',
        or: 'ou',
    },
    actions: {
        create: 'Créer',
        edit: 'Modifier',
        delete: 'Supprimer',
        save: 'Enregistrer',
        cancel: 'Annuler',
        confirm: 'Confirmer',
        add: 'Ajouter',
        remove: 'Retirer',
        update: 'Mettre à jour',
        close: 'Fermer',
        submit: 'Soumettre',
        reset: 'Réinitialiser',
        load: 'Charger',
        export: 'Exporter',
        import: 'Importer',
        archive: 'Archiver',
        restore: 'Restaurer',
        deactivate: 'Désactiver',
        activate: 'Activer',
    },
    auth: {
        signIn: 'Se connecter',
        signOut: 'Se déconnecter',
        signUp: 'S\'inscrire',
        username: 'Nom d\'utilisateur',
        password: 'Mot de passe',
        confirmPassword: 'Confirmer le mot de passe',
        displayName: 'Nom d\'affichage',
        email: 'E-mail',
        role: 'Rôle',
        createAccount: 'Créer un compte',
        dontHaveAccount: 'Vous n\'avez pas de compte ?',
        alreadyHaveAccount: 'Vous avez déjà un compte ?',
        signInToAccount: 'Connectez-vous à votre compte',
        createYourAccount: 'Créez votre compte',
        enterUsername: 'Entrez votre nom d\'utilisateur',
        enterPassword: 'Entrez votre mot de passe',
        chooseUsername: 'Choisissez un nom d\'utilisateur',
        yourFullName: 'Votre nom complet',
        atLeast6Chars: 'Au moins 6 caractères',
        confirmPasswordPlaceholder: 'Confirmez votre mot de passe',
        pleaseEnterCredentials: 'Veuillez entrer le nom d\'utilisateur et le mot de passe',
        invalidCredentials: 'Nom d\'utilisateur ou mot de passe invalide',
        pleaseFillAllFields: 'Veuillez remplir tous les champs',
        passwordsDoNotMatch: 'Les mots de passe ne correspondent pas',
        passwordTooShort: 'Le mot de passe doit contenir au moins 6 caractères',
        usernameExists: 'Ce nom d\'utilisateur existe déjà',
        demoCredentials: 'Identifiants de démonstration',
        admin: 'Administrateur',
        manager: 'Chef de projet',
        developer: 'Développeur',
        viewer: 'Observateur',
        contactAdminForRole: 'Contactez l\'administrateur pour changer de rôle',
        usernameCannotBeChanged: 'Le nom d\'utilisateur ne peut pas être modifié',
    },
    statuses: {
        backlog: 'Backlog',
        todo: 'À faire',
        inProgress: 'En cours',
        inReview: 'En revue',
        done: 'Terminé',
        planned: 'Planifié',
        inProgressSprint: 'En cours (Sprint)',
        completed: 'Terminé',
        allStatus: 'Tous les statuts',
    },
    priorities: {
        critical: 'Critique',
        high: 'Haute',
        medium: 'Moyenne',
        low: 'Basse',
    },
    messages: {
        noProjects: 'Aucun projet pour le moment',
        noTasks: 'Aucune tâche',
        confirmDelete: 'Êtes-vous sûr de vouloir supprimer cet élément ?',
        saved: 'Enregistré avec succès',
        error: 'Une erreur est survenue',
        noTasksAssigned: 'Aucune tâche ne vous est assignée',
        noActivityYet: 'Aucune activité pour le moment',
        confirmReset: 'Cela réinitialisera toutes les données à l\'état initial. Continuer ?',
        removeUserConfirm: 'Êtes-vous sûr de vouloir retirer cet utilisateur ?',
        deleteProjectConfirm: 'Êtes-vous sûr de vouloir supprimer ce projet ?',
        archiveProjectConfirm: 'Êtes-vous sûr de vouloir archiver ce projet ?',
    },
    settings: {
        title: 'Paramètres',
        theme: 'Thème',
        language: 'Langue',
        languageAndRegion: 'Langue et région',
        gitConfig: 'Configuration Git',
        gitIntegration: 'Intégration Git',
        gitProvider: 'Fournisseur Git',
        repositoryUrl: 'URL du dépôt',
        seedData: 'Données de démonstration',
        seedDataDescription: 'Chargez des projets exemples avec des tâches, des sprints et des épics pour les tests. Cela réinitialisera toutes les données à l\'état initial.',
        loadSeedData: 'Charger les données de démonstration',
        seedDataConfirm: 'Cela réinitialisera toutes les données à l\'état initial. Continuer ?',
        appearance: 'Apparence',
        notifications: 'Notifications',
    },
    themes: {
        summer: 'Été',
        spring: 'Printemps',
        autumn: 'Automne',
        winter: 'Hiver',
        day: 'Jour',
        night: 'Nuit',
        summerDay: 'Journée d\'été',
        summerNight: 'Nuit d\'été',
        springDay: 'Journée de printemps',
        springNight: 'Nuit de printemps',
        autumnDay: 'Journée d\'automne',
        autumnNight: 'Nuit d\'automne',
        winterDay: 'Journée d\'hiver',
        winterNight: 'Nuit d\'hiver',
        highContrast: 'Contraste élevé',
        selectTheme: 'Sélectionner un thème',
    },
    time: {
        hours: 'heures',
        minutes: 'minutes',
        days: 'jours',
        weeks: 'semaines',
        justNow: 'à l\'instant',
        minutesAgo: 'il y a {{count}}m',
        hoursAgo: 'il y a {{count}}h',
        daysAgo: 'il y a {{count}}j',
        updatedAt: 'Mis à jour',
    },
    reports: {
        velocity: 'Vélocité',
        burndown: 'Burndown',
        burnup: 'Burnup',
        cycleTime: 'Temps de cycle',
        leadTime: 'Temps de traitement',
        throughput: 'Débit',
        gantt: 'Gantt',
        cumulativeFlow: 'Flux cumulé',
    },
    globalSearch: {
        placeholder: 'Rechercher des projets, tâches, sprints...',
        noResults: 'Aucun résultat trouvé',
        projects: 'Projets',
        tasks: 'Tâches',
        sprints: 'Sprints',
        epics: 'Épics',
    },
    notifications: {
        title: 'Notifications',
        markAllRead: 'Tout marquer comme lu',
        clearAll: 'Tout effacer',
        empty: 'Aucune notification',
        unread: '{count} non lu(s)',
    },
    dashboard: {
        totalProjects: 'Total des projets',
        totalTasks: 'Total des tâches',
        completion: 'Achèvement',
        statusBreakdown: 'Répartition par statut',
        createProject: 'Créer un projet',
        loadSeedData: 'Charger les données exemples',
        noProjects: 'Aucun projet pour le moment',
        getStarted: 'Commencez par créer un nouveau projet ou charger des données exemples.',
        projects: 'Projets',
        newProject: 'Nouveau projet',
        createNewProject: 'Créer un nouveau projet',
        projectName: 'Nom du projet',
        description: 'Description',
        workflow: 'Flux de travail',
        skipToMain: 'Aller au contenu principal',
        projectProgress: 'Progression du projet',
        quickActions: 'Quick Actions',
        manageTasks: 'Manage tasks and track progress',
        trackTime: 'Track time for your tasks',
    },
    calendar: {
        jalali: 'Jalali',
        hijri: 'Hijri',
        gregorian: 'Grégorien',
    },
    accessibility: {
        skipToMain: 'Aller au contenu principal',
        board: 'Tableau de tâches',
        projectList: 'Liste des projets',
        mainNav: 'Navigation principale',
        selectTheme: 'Sélectionner un thème',
        projectDashboard: 'Tableau de bord du projet',
        toggleSidebar: 'Toggle sidebar',
    },
    board: {
        title: 'Tableau',
        kanban: 'Kanban',
        scrum: 'Scrum',
    },
    task: {
        title: 'Tâche',
        createTask: 'Créer une tâche',
        editTask: 'Modifier la tâche',
        deleteTask: 'Supprimer la tâche',
        assignee: 'Assigné à',
        unassigned: 'Non assigné',
        storyPoints: 'Points de récit',
        labels: 'Étiquettes',
        description: 'Description',
        acceptanceCriteria: 'Critères d\'acceptation',
        timeLog: 'Journal de temps',
        comments: 'Commentaires',
        addComment: 'Ajouter un commentaire',
        noComments: 'Aucun commentaire pour le moment',
        status: 'Statut',
        priority: 'Priorité',
        created: 'Créé',
        updated: 'Mis à jour',
        started: 'Commencé',
    },
    sprint: {
        title: 'Sprint',
        createSprint: 'Créer un sprint',
        sprintGoal: 'Objectif du sprint',
        committedPoints: 'Points engagés',
        completedPoints: 'Points terminés',
        velocity: 'Vélocité',
        planned: 'Planifié',
        inProgress: 'En cours',
        completed: 'Terminé',
    },
    team: {
        title: 'Équipe',
        members: 'Membres',
        role: 'Rôle',
        availability: 'Disponibilité',
        assignedTasks: 'Tâches assignées',
        activeTasks: 'Tâches actives',
        doneTasks: 'Tâches terminées',
    },
    timeTracking: {
        title: 'Suivi du temps',
        timer: 'Minuteur',
        manualEntry: 'Saisie manuelle',
        startTime: 'Heure de début',
        stopTime: 'Heure de fin',
        duration: 'Durée',
        date: 'Date',
        totalHours: 'Heures totales',
        entries: 'Entrées',
        noEntries: 'Aucune entrée pour le moment',
        hours: 'Hours',
        minutes: 'Minutes',
    },
    admin: {
        dashboard: 'Tableau de bord admin',
        projects: 'Projets',
        totalTasks: 'Total des tâches',
        storyPoints: 'Points de récit',
        taskStatusBreakdown: 'Répartition des statuts de tâches',
        projectProgress: 'Progression du projet',
        teamWorkload: "Charge de l'équipe",
        assigned: 'Assignées',
        active: 'Actives',
    },
    myTasks: {
        title: 'Mes tâches',
        total: 'Total',
        inProgress: 'En cours',
        inReview: 'En revue',
        done: 'Terminé',
        completion: 'Achèvement',
        allStatus: 'Tous les statuts',
        allProjects: 'Tous les projets',
        noTasksAssigned: 'Aucune tâche ne vous est assignée',
    },
    activity: {
        title: 'Fil d\'activité',
        commentsOnYourTasks: 'Commentaires sur vos tâches',
        allActivity: 'Toute l\'activité',
        noActivityYet: 'Aucune activité pour le moment',
        commentedOn: 'a commenté sur',
        movedTo: 'a déplacé vers',
    },
    profile: {
        title: 'Profil',
        avatar: 'Avatar',
        dragDropImage: 'Glissez-déposez une image ici, ou parcourez les fichiers',
        browse: 'Parcourir',
        imageFormats: 'PNG, JPG, WEBP jusqu\'à 2 Mo',
        removePhoto: 'Supprimer la photo',
        saveChanges: 'Enregistrer les modifications',
        profileSaved: 'Profil enregistré',
        contactAdmin: 'Contactez l\'administrateur pour les changements de rôle',
    },
};
//# sourceMappingURL=fr.js.map